// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-13ZRq","header":"header-BYA78","body":"body-38Jus","footer":"footer-22DDN","title":"title-11GoA","icon":"icon-Qnko4"};